module.exports = __webpack_public_path__ + "images/Forward.9bc2c91aa0a43bc253986ed3010e140f.svg";